<div class="loader" ng-class="{show: showLoader}">
    <div class="bit bit1"></div>
    <div class="bit bit2"></div>
    <div class="bit bit3"></div>
    <div class="bit bit4"></div>
    <div class="bit bit5"></div>
</div>